module.exports = __webpack_public_path__ + "static/media/sportstrans.059b8eac.png";